import styled from 'styled-components'

export const Highlight = styled.h5`
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 18px;
  margin-bottom: 0;
`

export const Percentage = styled.span<{ $isMaxValue: boolean }>`
  background-color: ${({ theme, $isMaxValue }) =>
    $isMaxValue ? theme.colors.brand.blue : 'transparent'};
  color: ${({ theme, $isMaxValue }) => ($isMaxValue ? 'white' : theme.colors.text.primary)};
  padding: 8px 16px;
  border-radius: 8px;
`

const TableRow = styled.div`
  display: flex;
`

const TableCell = styled.div`
  width: 25%;
  min-width: 150px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const TableHeaderRow = styled(TableRow)``

export const TableHeaderFirstCell = styled(TableCell)`
  background-color: ${({ theme }) => theme.colors.brand.blue};
  color: white;
  font-size: 12px;
  ${Highlight} {
    color: white;
  }
}
`

export const TableHeaderCell = styled(TableCell)`
  background-color: white;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 16px;
`

export const TableBody = styled.div`
  @media (min-width: 768px) {
    overflow: auto;
  }
`

export const TableBodyRow = styled(TableRow)<{ $isCurrentLevel: boolean; $rowIndex: number }>`
  background-color: ${({ theme, $isCurrentLevel, $rowIndex }) =>
    $isCurrentLevel
      ? `${theme.colors.blackPearlBlue.shade200}33`
      : $rowIndex % 2 === 0
        ? theme.colors.coolGray.cool100
        : 'white'};
`

export const TableBodyFirstCell = styled(TableCell)`
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  padding-right: 0;
`

export const TableBodyCell = styled(TableCell)<{ $isCurrentLevel: boolean }>`
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
  font-family: ${({ theme, $isCurrentLevel }) =>
    $isCurrentLevel ? theme.fontFamilies.gotham : theme.fontFamilies.roboto};
  font-size: 20px;
  font-weight: ${({ $isCurrentLevel }) => ($isCurrentLevel ? 'bold' : 'normal')};
  align-items: center;
`

export const TierNameCellWrapper = styled.div<{ $rowIndex: number }>`
  border-right: 1px solid
    ${({ theme, $rowIndex }) =>
      $rowIndex % 2 === 0 ? theme.colors.coolGray.cool300 : 'transparent'};
`

export const TierSalesThreshold = styled.span`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 16px;
`
